import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import InterfaceActions from 'V2/components/InterfaceActions';
import { Container } from './styles';
import History from 'utils/history';

const VisorInteractivo = () => {
  const { tipointeractivo } = useParams();
  const data = [
    {
      id: 'procedimientos',
      //model: 'https://chinalcopruebafront-paseo-virtual-chi.vercel.app/',
      model: 'https://www.eduverso.pe/Procedimientos_Interactivos_Chinalco/inicio.html',
      // 'https://quellaveco-paseo-virtual.vercel.app/',
    },
    {
      id: 'equipos',
      //model: 'https://chinalcopruebafront-visor-equipos-gilt.vercel.app/',
      model: 'https://www.eduverso.pe/Procedimientos_Interactivos_Chinalco/inicio.html',
      // 'https://quellaveco-visor-equipos.vercel.app/',
    },
  ];
  const area = data.find(x => x.id === tipointeractivo);

  const goBack = () => History.push('/');
  const [state] = useState({
    model: area.model,
    // title: "Bomba de Alimentación",
    // model: "/3d/Bomba_de_alimentacion/Bomba_de_alimentacion.html",
  });
  // useEffect(()=>{
  //     const {tipointeractivo} = useParams();
  //     var area = data.find((x) => x.id === tipointeractivo);
  //     setModel(area.model)
  // }, [model])

  return (
    <Container>
      <InterfaceActions
        hasBack
        backMessage="Volver al inicio"
        onClickBack={goBack}
      />
      <main>
        <iframe title="____visor____" frameBorder={0} src={state.model} />
      </main>
    </Container>
  );
};

export default VisorInteractivo;
